var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import classNames from "classnames";
import React, { forwardRef } from "react";
import MapBox, { NavigationControl } from "react-map-gl";
/**
 * **Warning**
 *
 * In order for the map to work properly the following css link must be added to the webpage
 *
 * ```<link href="https://api.mapbox.com/mapbox-gl-js/v2.12.0/mapbox-gl.css" rel="stylesheet" />```\
 *
 * A mapboxAccessToken is also required to gain full functionality.
 */
export const Map = /*#__PURE__*/forwardRef((_a, ref) => {
  var children = _a.children,
    className = _a.className,
    _a$showNavControl = _a.showNavControl,
    showNavControl = _a$showNavControl === void 0 ? true : _a$showNavControl,
    mapboxAccessToken = _a.mapboxAccessToken,
    _a$attributionControl = _a.attributionControl,
    attributionControl = _a$attributionControl === void 0 ? false : _a$attributionControl,
    _a$style = _a.style,
    style = _a$style === void 0 ? {
      width: "100%",
      height: "100%"
    } : _a$style,
    _a$initialViewState = _a.initialViewState,
    initialViewState = _a$initialViewState === void 0 ? {
      latitude: 51.5072,
      longitude: 0.1276,
      zoom: 9
    } : _a$initialViewState,
    _a$mapStyle = _a.mapStyle,
    mapStyle = _a$mapStyle === void 0 ? "mapbox://styles/scandotcom/cl8wv327p004x15n2506gaeis" : _a$mapStyle,
    props = __rest(_a, ["children", "className", "showNavControl", "mapboxAccessToken", "attributionControl", "style", "initialViewState", "mapStyle"]);
  if (!mapboxAccessToken) {
    console.log("Missing mapboxAccessToken.");
  }
  const mapStyles = classNames("overflow-hidden [&_.mapboxgl-marker:hover]:!z-[3]", className);
  return /*#__PURE__*/React.createElement("div", {
    className: mapStyles
  }, /*#__PURE__*/React.createElement(MapBox, Object.assign({
    mapboxAccessToken: mapboxAccessToken,
    ref: ref,
    attributionControl: attributionControl,
    initialViewState: initialViewState,
    style: style,
    mapStyle: mapStyle
  }, props), showNavControl && /*#__PURE__*/React.createElement(NavigationControl, {
    position: "top-right",
    showCompass: false
  }), children));
});